export default __webpack_public_path__ + "static/media/foodie.63030798.png";